import { render, staticRenderFns } from "./EnglishFilter.vue?vue&type=template&id=b5a850f8&scoped=true"
import script from "./EnglishFilter.vue?vue&type=script&lang=js"
export * from "./EnglishFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a850f8",
  null
  
)

export default component.exports